export enum ETimeFrame {
    Today = 0,
    LastWeek = 1,
    LastMonth = 2,
    AllTime = 3
}
